<table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">
  <ng-container matColumnDef="videoHelpKey">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Video key </th>
    <td mat-cell *matCellDef="let help">
      {{ help.videoHelpKey}} </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre </th>
    <td mat-cell *matCellDef="let help">{{ help.title}} </td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
    <td mat-cell *matCellDef="let help">{{ help.description}} </td>
  </ng-container>

  <ng-container matColumnDef="videoName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom de vidéo </th>
    <td mat-cell *matCellDef="let help">{{ help.videoName}} </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
    <td mat-cell *matCellDef="let help" class="actionsCell">
      <fa-icon [icon]="getFaIcon('faEdit')" matTooltip="Editer l'aide vidéo" appChangeColorTheme attribute="color" (click)="openDialogAddEditHelp('edit', help.videoHelpKey, help)"></fa-icon>
      <fa-icon [icon]="getFaIcon('faTrashAlt')" matTooltip="Supprimer l'aide vidéo" appChangeColorTheme attribute="color" (click)="deleteHelp(help)"></fa-icon>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedColumns;">
  </tr>
</table>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  (page)="pageEvent = $event" [color]="color">
</mat-paginator>
